<template>
  <form class="nx-form nx-relation-card" :class="{ 'nx-active': active }" :data-vv-scope="scope">
      <v-progress-linear
        v-show="loading"
        indeterminate
        background-opacity="0"
        height="2"
      />

      <v-layout class="row wrap px-3">
        <v-flex class="xs12">
          <nx-clipping-form-selector
            :id="`form-field-${scope}-clipping`"
            :allow-only-source-aspect-ratio="allowOnlySourceAspectRatio"
            :additional-filters="clippingSelectorAdditionalFilters"
            :aspect-ratios="aspectRatios"
            :before-create-clipping-aliases="beforeCreateClippingAliases"
            :disabled="loading || disabled"
            :disable-crop="disableCrop"
            :label="$t('message.form.fields.addRelation')"
            :allowNonPublished="allowNonPublished"
            :title-length="7"
            :type="types"
            :value="draft.clipping"
            name="clipping"
            validation="required"
            @input="relationDeleted(uuid, ...$event)"
          />
        </v-flex>
      </v-layout>
  </form>
</template>

<script>
import { cloneDeep, get } from 'lodash';
import RelationCardForm from '@/modules/relation/card/form/RelationCardForm';
import NxClippingFormSelector from '@/modules/clipping/form/Selector';
import RelationDeletionMixin from '@/modules/relation/mixins/relation-deletion.mixin';

export default {
  name: 'nx-relation-card-with-clipping-form',
  extends: RelationCardForm,
  mixins: [RelationDeletionMixin],
  components: {
    NxClippingFormSelector,
  },
  props: {
    aspectRatios: {
      type: Array,
      default: () => ['source-aspect-ratio'],
    },
    allowOnlySourceAspectRatio: Boolean,
  },
  computed: {
    updateSpecificField() {
      return {
        destContent: this.updateDestContent,
        clipping: this.updateClipping,
      };
    },
  },
  methods: {
    async updateClipping(clippingCard) {
      if (!clippingCard) {
        return {
          destContent: get(this.value, 'destContent', null),
          clipping: null,
        };
      }

      const currentDestContentId = get(this.value, 'destContent.id', false);
      if (!currentDestContentId || clippingCard.image.id !== currentDestContentId) {
        return this.updateDestContent(
          clippingCard.image.id,
          clippingCard.image,
          { aspectRatios: this.aspectRatios },
        );
      }

      const draft = cloneDeep(this.value);
      draft.clipping = clippingCard;
      return draft;
    },
  },
};
</script>
